export const ROLES = {
  superAdmin: 'superAdmin',
};
